import { Component, Input } from '@angular/core';
import { StockMoveInternal } from '../stock-move-internals/stock-move-internal.model';
import { BaseGridComponent } from 'projects/libraries/syslink-components/src/lib/grid/base-grid/base-grid.component';
import { ContextMenuItemAction } from 'projects/libraries/syslink-components/src/lib/context-menus/context-menu-item-action';
import { SyslinkColumn } from 'projects/libraries/syslink-components/src/lib/helpers/SyslinkColumn';
import { StockMoveInternalsService } from '../stock-move-internals/stock-move-internals.service';
import { DXCell } from 'projects/libraries/syslink-components/src/lib/grid/cells/dxcell';
import { SelectDescriptor } from 'devextreme/data';

@Component({
  selector: 'app-stock-move-internal-grid',
  templateUrl: './stock-move-internal-grid.component.html',
  styleUrls: ['./stock-move-internal-grid.component.scss']
})
export class StockMoveInternalGridComponent extends BaseGridComponent<StockMoveInternal> {

  @Input() override detailsUrl: string = '/stockmoves/internals';
  @Input() override storageKey: string = 'stock-move-internals';
  @Input() public contextMenuItems: ContextMenuItemAction[] = [];
  @Input() showPager: boolean = true;
  @Input() public override expand?: string | string[] = ['CurrentStatusLink.StatusId'];
  @Input() public override select?: SelectDescriptor<any> = ['Id', 'No', 'Deadline', 'ExternalReference','ResponsibleUserId.Fullname', 'Date'];

  public columns: SyslinkColumn[] = [
    new SyslinkColumn({ field: "No", label: "GRID.CAPTION.NO", width: 150, sortIndex: 2, sortDirection: 'desc' }),
    new SyslinkColumn({ field: "CurrentStatusLink.StatusId.Name", label: "Status", cellTemplate: 'statusText-cell', data: { getStatusLabel: this.getStatusCellLabel, getStatusDate: this.getStatusCellDate, getStatusClass: this.getStatusCellClass, getStatusColor: this.getStatusCellColor }, width: 120 }),
    new SyslinkColumn({ field: "Deadline", label: 'StockMoveInternal.Validity', type: "date" }),
    new SyslinkColumn({ field: "ExternalReference", label: "External reference", visible: true, width: 150 }),
    new SyslinkColumn({ field: "ResponsibleUserId.Fullname", label: "Responsible", width: 120 }),
    new SyslinkColumn({ field: "Date", label: "Date", type: "date", visible: false, width: 150 }),
    new SyslinkColumn({ field: "CurrentStatusLink.StatusId.Sequence", label: 'status internal', sortIndex: 1, sortDirection: 'asc', width: 0, visible: false, filterable: false, headerFilterable: false, sortable: false })
  ];

  constructor(
    public StockMoveInternalsService: StockMoveInternalsService,
  ) {
    super();
  }

  getStatusCellLabel(cell: DXCell) {
    return cell.data.CurrentStatusLink.StatusId.Name;
  }

  getStatusCellDate(cell: DXCell) {
    return cell.data.CurrentStatusLink.Date;
  }

  getStatusCellClass(cell: DXCell) {
    let statusClass = 'text-white text-center'

    const statusCode = (<string>cell.data.CurrentStatusLink.StatusId.Code).toLowerCase().split('.')[1];
    if (statusCode == undefined) return;
    statusClass += ' ' + statusCode;
    return statusClass;
  }

  getStatusCellColor(cell: DXCell) {
    return cell.data.CurrentStatusLink.StatusId.Color;
  }
}


